import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './tests.component.html',
	styleUrls: ['./tests.component.css']
})

export class TestsComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/tests.component.ts